import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { SERVICES } from "../lib/content";
import { useSite } from "../context/SiteContext";

export const ServiceList = () => {
  const { site } = useSite();
  const list = SERVICES.map((s) => ({ ...s, ...(site.services[s.slug] || {}) }));
  return (
      <div id="services" className="mx-auto max-w-7xl scroll-mt-28 space-y-20 px-6 py-20" data-testid="services-section">
        {list.map((s, i) => (
          <section key={s.slug} id={s.slug} className={`grid scroll-mt-28 items-center gap-10 lg:grid-cols-2 ${i % 2 ? "lg:[&>*:first-child]:order-2" : ""}`} data-testid={`service-${s.slug}`}>
            <div className="relative overflow-hidden rounded-[2rem]">
              <img src={s.image} alt={s.title} className="aspect-[4/3] w-full object-cover" />
              <span className="absolute left-5 top-5 rounded-full bg-[#0E0B0D] px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-[#EBD08A]">0{i + 1}</span>
            </div>
            <div>
              <p className="font-script text-4xl text-[#FF1F8E]">{s.script}</p>
              <h2 className="font-display text-3xl font-bold sm:text-4xl">{s.title}</h2>
              <div className="stitch-line my-5 w-24" />
              <p className="text-base text-[#0E0B0D]/70 sm:text-lg">{s.blurb}</p>
              <ul className="mt-6 grid grid-cols-2 gap-3">
                {s.items.map((it) => (
                  <li key={it} className="flex items-center gap-2 text-sm font-medium sm:text-base">
                    <span className="grid h-6 w-6 place-items-center rounded-full bg-[#FFF4F8] text-[#FF1F8E]"><Check className="h-3.5 w-3.5" /></span>{it}
                  </li>
                ))}
              </ul>
              <Link to={`/order?type=${encodeURIComponent(s.title)}`} className="btn-pink mt-8" data-testid={`service-order-${s.slug}`}>Request this <ArrowRight className="h-4 w-4" /></Link>
            </div>
          </section>
        ))}
      </div>
  );
};
